import { render, staticRenderFns } from "./AudioPlayer.vue?vue&type=template&id=d0bb204c&scoped=true&"
import script from "./AudioPlayer.vue?vue&type=script&lang=ts&"
export * from "./AudioPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./AudioPlayer.vue?vue&type=style&index=0&id=d0bb204c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0bb204c",
  null
  
)

export default component.exports